module.exports = __webpack_public_path__ + "static/media/04.69d69746.jpg";